import React from 'react'

import { usePageData } from '../../../hooks'
import { Carousel } from '../../Carousel'
import { DetailCaption } from './DetailCaption'


import './ProjectDetail.scss'

const ProjectDetail = () => {
  const { loading, pageData } = usePageData()
  const {
    title,
    images,
    client,
    status,
    category,
    content,
    filePath
  } = pageData || {}


  return (
    <div className="project-detail">
      <div className="full-size">
        { !loading && images &&
          <Carousel
            className="project-category"
            onSlideChange={ (val) => console.log(val) }
            overlay={ DetailCaption({ title, client, status, category, content }) }
            loading={ loading }
            slides={ images.map(fileName => ({ filePath, fileName })) }
          />
        }
      </div>
    </div>
  )
}

export default ProjectDetail
